
(function () {
  if (
    window.__dwSiteSparkle ||
    (window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches)
  ) return;

  window.__dwSiteSparkle = true;

  function initSparkler() {
    if (!document.body) return;

    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    if (!ctx) return;

    canvas.className = "dw-site-sparks";
    canvas.setAttribute("aria-hidden", "true");
    document.body.appendChild(canvas);
    document.documentElement.classList.add("dw-sparkler");

    var W = 0, H = 0, raf = 0;
    var sparks = [];
    var trail = [];
    var tip = null;
    var touchActive = false;
    var newStroke = false;
    var linger = null;

    var desktop = window.matchMedia("(min-width: 990px)");
    var DENSITY = 6;

    function settings() {
      return desktop.matches
        ? { size: 1, life: 1 }
        : { size: 1.5, life: 1.8 };
    }

    function resize() {
      var dpr = Math.min(2, window.devicePixelRatio || 1);

      W = window.innerWidth;
      H = window.innerHeight;

      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      kick();
    }

    function emit(x, y, speed, life, size) {
      var angle = Math.random() * Math.PI * 2;

      sparks.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 0.4,
        life: life,
        max: life,
        size: size,
        split: Math.random() < 0.18
      });
    }

    function glow(x, y, radius, alpha) {
      var gradient = ctx.createRadialGradient(
        x, y, 0, x, y, radius
      );

      gradient.addColorStop(0, "rgba(255,250,230,1)");
      gradient.addColorStop(0.25, "rgba(255,200,90,.85)");
      gradient.addColorStop(1, "rgba(255,150,40,0)");

      ctx.globalAlpha = alpha;
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
    }

    function release() {
      var s = settings();

      if (tip && touchActive) {
        var duration = 350 * s.life;

        linger = {
          x: tip.x,
          y: tip.y,
          until: Date.now() + duration,
          span: duration
        };
      }

      tip = null;
      touchActive = false;
    }

    function frame() {
      ctx.clearRect(0, 0, W, H);

      var now = Date.now();
      var s = settings();
      var currentTip = tip;
      var power = 1;
      var source = currentTip
        ? (touchActive ? "touch" : "mouse")
        : null;

      if (!currentTip && linger) {
        var remaining = (linger.until - now) / linger.span;

        if (remaining > 0) {
          currentTip = linger;
          power = remaining;
          source = "linger";
        } else {
          linger = null;
        }
      }

      if (source === "touch") {
        var last = trail[trail.length - 1];

        trail.push({
          x: currentTip.x,
          y: currentTip.y,
          t: 1,
          fade: 0.018 / s.life,
          size: s.size,
          brk: !last || newStroke
        });

        newStroke = false;
      }

      trail = trail.filter(function (p) {
        p.t -= p.fade;
        return p.t > 0;
      });

      ctx.lineCap = "round";

      for (var i = 1; i < trail.length; i++) {
        var p0 = trail[i - 1];
        var p1 = trail[i];

        if (p1.brk) continue;

        ctx.strokeStyle =
          "rgba(255,205,120," + p1.t * 0.55 + ")";

        ctx.lineWidth = 2.2 * p1.t * p1.size;
        ctx.beginPath();
        ctx.moveTo(p0.x, p0.y);
        ctx.lineTo(p1.x, p1.y);
        ctx.stroke();
      }

      if (currentTip) {
        var count = Math.round(
          (DENSITY + Math.random()) * power
        );

        for (var k = 0; k < count; k++) {
          emit(
            currentTip.x,
            currentTip.y,
            (1.5 + Math.random() * 3.5) * s.size,
            (22 + Math.random() * 22) * s.life,
            s.size
          );
        }

        glow(
          currentTip.x,
          currentTip.y,
          22 * s.size,
          power
        );
      }

      sparks = sparks.filter(function (p) {
        var oldX = p.x;
        var oldY = p.y;

        p.vy += 0.06;
        p.vx *= 0.985;
        p.vy *= 0.985;

        p.x += p.vx;
        p.y += p.vy;
        p.life--;

        var t = p.life / p.max;

        if (t <= 0) return false;

        ctx.strokeStyle = t > 0.6
          ? "rgba(255,244,210," + t + ")"
          : "rgba(235," + (120 + 90 * t | 0) + ",40," + t + ")";

        ctx.lineWidth = (1.4 * t + 0.3) * p.size;
        ctx.beginPath();
        ctx.moveTo(
          oldX - p.vx * 1.5,
          oldY - p.vy * 1.5
        );
        ctx.lineTo(p.x, p.y);
        ctx.stroke();

        if (p.split && t < 0.55) {
          p.split = false;

          for (var m = 0; m < 3; m++) {
            emit(
              p.x,
              p.y,
              (1 + Math.random() * 1.5) * p.size,
              12 + Math.random() * 10,
              p.size
            );
          }
        }

        return true;
      });

      return !!(
        currentTip ||
        linger ||
        sparks.length ||
        trail.length
      );
    }

    function loop() {
      raf = 0;

      if (frame()) {
        raf = requestAnimationFrame(loop);
      }
    }

    function kick() {
      if (!raf) {
        raf = requestAnimationFrame(loop);
      }
    }

    resize();

    window.addEventListener("resize", resize, {
      passive: true
    });

    document.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse") return;

      tip = {
        x: e.clientX,
        y: e.clientY
      };

      touchActive = false;
      kick();
    }, { passive: true });

    document.addEventListener("mouseout", function (e) {
      if (!e.relatedTarget && !touchActive) {
        tip = null;
      }
    });

    function onTouch(e) {
      var t = e.touches && e.touches[0];
      if (!t) return;

      if (!touchActive) {
        newStroke = true;
      }

      touchActive = true;
      linger = null;

      tip = {
        x: t.clientX,
        y: t.clientY
      };

      kick();
    }

    function onTouchEnd() {
      release();
      kick();
    }

    document.addEventListener("touchstart", onTouch, {
      passive: true
    });

    document.addEventListener("touchmove", onTouch, {
      passive: true
    });

    document.addEventListener("touchend", onTouchEnd, {
      passive: true
    });

    document.addEventListener("touchcancel", onTouchEnd, {
      passive: true
    });

    if (desktop.addEventListener) {
      desktop.addEventListener("change", kick);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSparkler);
  } else {
    initSparkler();
  }
})();
